import React, { ReactNode, useEffect } from 'react';
import { useConfigurationSettings } from 'hooks/use-configuration-settings';
import { useConfigStore } from './store/config/useConfigStore';
import { LoadingOverlay } from 'components/core/loading-overlay';
import { TriangleAlert } from 'lucide-react';

export const NoAuthMiddleware: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const { data: configurationsSettings, isLoading, error } = useConfigurationSettings();
  const { configurationSettings: storeConfig, setConfigurationSettings } = useConfigStore();

  useEffect(() => {
    if (configurationsSettings) {
      setConfigurationSettings(configurationsSettings);
    }
  }, [configurationsSettings, setConfigurationSettings]);

  if (isLoading) {
    return <LoadingOverlay />;
  }

  if (error || !configurationsSettings) {
    const errorMessage = error?.message ?? 'Failed to load configuration settings';
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
        <div className="rounded-lg bg-red-50 border border-red-400 p-4 mb-2 transition-all duration-1000 ease-in-out opacity-100">
          <div className="flex items-center gap-1">
            <TriangleAlert className="text-error w-4 h-4" />
            <h1 className="text-error text-sm font-semibold">Something went wrong</h1>
          </div>
          <p className="text-error text-xs font-normal">{errorMessage}</p>
        </div>
      </div>
    );
  }

  if (!storeConfig) {
    return <LoadingOverlay />;
  }

  return <>{children}</>;
};
